<script setup lang="ts">
import { useCollectionsStore } from '~/stores/collections-store';
import IconAdd from '~icons/carbon/add';

const collectionsStore = useCollectionsStore();
</script>

<template>
  <button
    class="btn --primary --space-sm inline-flex items-center gap-2 text-sm"
    @click="() => collectionsStore.openCollectionModal()"
  >
    <IconAdd class="-mx-1.5 text-base" />
    <span>
      {{ $t('states.no_items_created.button_text', { noun: $t('states.noun.collections', 1) }) }}
    </span>
  </button>
</template>

<style scoped lang="postcss"></style>
